<template>
    <div>
        <div v-if="!car">
            <DxLoadIndicator
                    id="medium-indicator"
                    :height="20"
                    :width="20"
            />
            Загрузка
        </div>
        <div v-if="car" class="table-responsive-md">
            <div class="row select-car">
                <div class="col-12 col-md-4 col-lg-3">
                    <img :src="carFile" class="img-thumbnail rounded float-left mb-3" style="min-height: 200px; min-width: 200px; max-height: 200px" @click="openCarFile" :alt="carFile ? '' : 'Загрузка...'">
                </div>
                <div class="col-12 col-md-8 col-lg-9">
                    <div class="row">
                        <div class="col-12 col-md-4 col-lg-2 d-flex flex-row flex-md-column justify-content-start">
                            <p class="mr-2">
                                Номер авто:
                            </p>
                            <p class="item-text">
                                {{ car.number ? car.number : '-' }}
                            </p>
                        </div>
                        <div class="col-12 col-md-8 col-lg-3 mb-3 d-flex flex-row flex-md-column justify-content-start">
                            <p class="mr-2">
                                VIN-номер:
                            </p>
                            <p class="item-text">
                                {{ car.vin ? car.vin : '-' }}
                            </p>
                        </div>
                        <div class="col-12 col-md-6 col-lg-3 d-flex flex-row flex-md-column justify-content-start">
                            <p class="mr-2">
                                Бренд:
                            </p>
                            <p class="item-text">
                                {{ car.brand ? car.brand : '-' }}
                            </p>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-row flex-md-column justify-content-start">
                            <p class="mr-2">
                                Модель:
                            </p>
                            <p class="item-text">
                                {{ car.model ? car.model : '-' }}
                            </p>
                        </div>
                        <div class="col-12 col-md-12 col-lg-2 mb-3 d-flex flex-row flex-md-column justify-content-start">
                            <p class="mr-2">
                                Спецификация:
                            </p>
                            <p class="item-text">
                                {{ getSpecificationName(car.specification) }}
                            </p>
                        </div>
                        <div class="col-12 col-md-6 col-lg-5 d-flex flex-row flex-md-column justify-content-start">
                            <p class="mr-2">
                                Кузов:
                            </p>
                            <p class="item-text">
                                {{ car.rollingStockTypeName ? car.rollingStockTypeName : '-' }}
                            </p>
                        </div>
                        <div class="col-12 col-md-6 col-lg-5 mb-3 d-flex flex-row flex-md-column justify-content-start">
                            <p class="mr-2">
                                Грузоподъемность:
                            </p>
                            <p class="item-text">
                                {{ car.capacity ? car.capacity : '-' }}
                            </p>
                        </div>
                        <div class="col-12 col-md-6 col-lg-3 d-flex flex-row flex-md-column justify-content-start">
                            <p class="mr-2">
                                Номер СР:
                            </p>
                            <p class="item-text">
                                {{ car.techicalPassport ? car.techicalPassport : '-' }}
                            </p>
                        </div>
                        <div class="col-12 col-md-6 col-lg-3 mb-3 d-flex flex-row flex-md-column justify-content-start">
                            <p class="mr-2">
                                Дата выдачи СР:
                            </p>
                            <p class="item-text">
                                {{ car.issuedDate ? car.issuedDate : '-' | moment("DD.MM.YYYY") }}
                            </p>
                        </div>
                        <div class="col-12 col-md-6 col-lg-3 d-flex flex-row flex-md-column justify-content-start">
                            <p class="mr-2">
                                Дата прохождения ТО:
                            </p>
                            <p class="item-text">
                                {{ car.techInspection ? car.techInspection : '-' | moment("DD.MM.YYYY") }}
                            </p>
                        </div>
                        <div class="col-12 col-md-6 col-lg-3 mb-3 d-flex flex-row flex-md-column justify-content-start">
                            <p class="mr-2">
                                Дата окончания СП:
                            </p>
                            <p class="item-text">
                                {{ car.finisedDateInsurance ? car.finisedDateInsurance : '-' | moment("DD.MM.YYYY") }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="car" class="mb-3">
                <ul class="nav nav-tabs" :id="'carTab-'+carId" role="tablist">
                    <li class="nav-item" role="presentation">
                        <a class="nav-link active" @click="getCarFiles(carId)" :id="'files-tab-'+carId" data-toggle="tab" :href="'#files-'+carId" role="tab" :aria-controls="'files-'+carId" aria-selected="true">Файлы ({{ car.files }})</a>
                    </li>
                </ul>
                <div class="tab-content" :id="'carTabContent-'+carId">
                    <div class="tab-pane fade show active" :id="'files-'+carId" role="tabpanel" :aria-labelledby="'files-tab-'+carId">
                        <DxDataGrid
                                id="CarFiles"
                                key-expr="fileId"
                                :data-source="carFiles"
                                :columns="columnsFiles"
                                :show-borders="true"
                                :row-alternation-enabled="true"
                                :show-row-lines="true"
                                :customize-columns="customizeColumnsFiles"
                        >
                            <template #file-name-template="{ data }">
                                <button :id="'btn-download-file-'+data.data.fileId" type="button" class="btn btn-link btn-sm p-0 text-left" @click="downloadFile(car.carId, data.data.fileId, data.data.fileName)">{{ data.data.fileName }}</button>
                            </template>
                        </DxDataGrid>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="carFileModal" tabindex="-1" aria-labelledby="carFileModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="carFileModalLabel">Транспортное средство</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <img :src="carFile" style="height: 100%; width: 100%;">
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Закрыть</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import jQuery from 'jquery';
    let $ = jQuery;
    import {httpClient} from '../../../shared/services';
    import localStore from '../store';
    import {DxLoadIndicator} from 'devextreme-vue/load-indicator';
    import { DxDataGrid } from 'devextreme-vue/data-grid';

    export default {
        name: "DetailCar",
        props: ['carId', 'Agent', 'getCars'],
        components: {
            DxLoadIndicator,
            DxDataGrid
        },
        data() {
            return {
                car: null,
                carFiles: null,
                carFile: 'data:application/png;base64,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',
                isLoadCarFile: false,
                columnsFiles: [
                    {
                        caption: 'Имя',
                        dataField: 'fileName',
                        allowSorting: false,
                        encodeHtml: false,
                        cellTemplate: "file-name-template",
                        allowHiding: false,
                    }, {
                        caption: 'Тип файла',
                        dataField: 'fileKind',
                        allowSorting: false,
                        width: 150
                    }, {
                        caption: 'Примечание',
                        dataField: 'note',
                        allowSorting: false,
                        width: 500
                    }
                ],
            }
        },
        mounted() {
            localStore.dispatch('getCar', {tokenId: this.Agent.tokenId, carId: this.carId}).then(() => {
                this.car = localStore.state.car;

                this.getCarFiles(this.car.carId)
            });
        },
        methods: {
            getCarFiles(carId) {
                this.carFiles = null;

                localStore.dispatch('getCarFiles', {tokenId: this.Agent.tokenId, carId: carId}).then(() => {
                    this.carFiles = localStore.state.carFiles;

                    this.carFiles.forEach(function (file) {
                        switch (file.fileKind) {
                            case "ФОТО-ТС":
                                this.loadCarFile(file.fileId);
                                break;
                        }
                    }, this);
                })
            },
            downloadFile(carId, fileId, fileName) {
                $('#btn-download-file-'+fileId).html('Загрузка...');
                $('#btn-download-file-'+fileId).prop('disabled', true);

                httpClient.get(`v2/FilesStarage/${fileId}/Download?tokenId=${this.Agent.tokenId}`)
                    .then((file) => {
                        let fileExt = fileName.split('.').pop();

                        const linkSource = `data:application/${fileExt};base64,${file.data}`;
                        const downloadLink = document.createElement('a');
                        document.body.appendChild(downloadLink);

                        downloadLink.href = linkSource;
                        downloadLink.target = '_self';
                        downloadLink.download = fileName;
                        downloadLink.click();

                        downloadLink.remove();

                        $('#btn-download-file-'+fileId).html(fileName);
                        $('#btn-download-file-'+fileId).prop('disabled', false);
                    })
                    .catch(() => {
                        $('#btn-download-file-'+fileId).html(fileName);
                        $('#btn-download-file-'+fileId).prop('disabled', false);
                    });
            },
            customizeColumnsFiles(columns) {
                if(columns.length > 0) {
                    if(this.$mq == 'sm' || this.$mq == 'md' || this.$mq == 'lg') {
                        columns[1].hidingPriority = 0;
                        columns[2].hidingPriority = 1;
                    } else {
                        columns[1].hidingPriority = null;
                        columns[2].hidingPriority = null;
                    }
                }
            },
            getSpecificationName(specification) {
                switch (specification) {
                    case 'spcTractor':
                        return 'Тягач';
                    case 'spcCar':
                        return 'Фургон';
                    case 'spcTrailer':
                        return 'Прицеп';
                }
            },
            loadCarFile(fileId) {
                this.carFile = '';
                httpClient.get(`v2/FilesStarage/${fileId}/Download?tokenId=${this.Agent.tokenId}`)
                    .then((file) => {
                        this.carFile = `data:application/png;base64,${file.data}`;
                        this.isLoadCarFile = true;
                    })
            },
            openCarFile() {
                if(this.isLoadCarFile) {
                    $('#carFileModal').modal({
                        backdrop: false
                    });
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .select-car {
        -ms-content-zooming: none;
        -webkit-tap-highlight-color: transparent;
        -webkit-text-size-adjust: none;
        -webkit-touch-callout: none;
        padding: 0;
        outline: 0;
        -webkit-print-color-adjust: exact;
        color-adjust: exact;
        color: #212529;
        font-weight: 400;
        font-size: 14px;
        font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans","Liberation Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
        line-height: 1.35715;

        p {
            margin-bottom: 0.5rem;
        }

        .item-text {
            border-style: none none dashed none;
            background: 0 0;
            border-bottom: 1px dashed #ced4da;
            border-radius: 0;
        }
    }
</style>
